import React, { Component } from 'react'
import { createTodo } from '../store/actions/todoActions';
import { connect } from 'react-redux';

class CreateTodo extends Component {
	state = {
		content: ''
	}

	handleChange = (e) => {
		this.setState({
			content: e.target.value
		});
	}

	handleSubmit = (e) => {
		e.preventDefault();
		document.getElementById("add-form").reset();

		this.props.createTodo(this.state);

		this.setState({
			content: ''
		})
	}

	render() {
		return (
			<div>
				<form onSubmit={ this.handleSubmit } id="add-form">
					<input onChange={ this.handleChange } type="text" placeholder="todo-name" required />
					<button>add todo</button>
				</form>
			</div>
		)
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		createTodo: (todo) => dispatch(createTodo(todo))
	}
}

export default connect(null, mapDispatchToProps)(CreateTodo);